import { useTranslation } from 'react-i18next';
import React from 'react';
import styles from './index.module.scss';
import { HelperTooltip, UnionAvatar } from '@/components';

export const SharedByGroupMemberTag = ({ user }: { user?: UnionAccount }) => {
  const { t } = useTranslation();

  return (
    <HelperTooltip
      title={`First shared to the group by ${(user as GeneralAccount)?.desc?.user?.web3_id}`}>
      <span className={styles.tag}>
        <UnionAvatar data={user} size={16} />
        <span className={styles.status}>{t('SharedByGroupMemberTag.14xpl6t')}</span>
      </span>
    </HelperTooltip>
  );
};
